import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import {
  QuizResultsCircular,
  type AssessmentRunningScoreBreakdown,
} from "../../quiz-results-circular/quiz-results-circular";
import { QuizCountdownCircle } from "../../quiz-countdown-circle/quiz-countdown-circle";
import {
  containerStyle,
  progressContainerStyle,
  progressRowStyle,
  progressLabelStyle,
  linearProgressStyle,
  headerTopRowStyle,
  timerAndProgressContainerStyle,
  resultsCircleWrapperStyle,
} from "./styles";

interface AssessmentHeaderQuizProps {
  totalAnswers?: number;
  remainingSeconds?: number;
  totalSeconds?: number;
  totalMaxScore?: number;
  scoresEarned?: number;
  bonusScore?: number;
  answeredQuestions?: number;
  mobileSubheader?: React.ReactNode;
  hidePointsEarned?: boolean;
  scoreBreakdown?: AssessmentRunningScoreBreakdown | null;
}

export const AssessmentHeaderQuiz: React.FC<AssessmentHeaderQuizProps> = ({
  totalAnswers = 12,
  remainingSeconds = 0,
  totalSeconds,
  totalMaxScore,
  scoresEarned,
  bonusScore,
  answeredQuestions,
  mobileSubheader,
  hidePointsEarned = false,
  scoreBreakdown = null,
}) => {
  const progress =
    totalAnswers && totalAnswers > 0 && answeredQuestions !== undefined
      ? Math.min(100, Math.round((answeredQuestions / totalAnswers) * 100))
      : 0;

  return (
    <Box sx={containerStyle}>
      <Box sx={headerTopRowStyle}>
        <Box sx={timerAndProgressContainerStyle}>
          {totalSeconds && totalSeconds > 0 ? (
            <QuizCountdownCircle
              remainingSeconds={Math.max(0, remainingSeconds)}
              totalSeconds={Math.max(1, totalSeconds)}
            />
          ) : null}

          <Box sx={progressContainerStyle}>
            <Box sx={progressRowStyle}>
              <Typography variant="body2" sx={progressLabelStyle}>
                Progress
              </Typography>
              <Typography variant="body2" sx={progressLabelStyle}>
                {progress}%
              </Typography>
            </Box>
            <Box sx={{ width: "100%" }}>
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={linearProgressStyle}
              />
            </Box>
            {mobileSubheader ? (
              <Box sx={{ mt: { xs: 0.5, md: 1 }, display: { xs: "block", md: "none" } }}>
                {mobileSubheader}
              </Box>
            ) : null}
          </Box>
        </Box>

        {!hidePointsEarned ? (
          <Box sx={resultsCircleWrapperStyle}>
            <QuizResultsCircular
              totalAnswers={totalAnswers}
              totalMaxScore={totalMaxScore}
              scoresEarned={scoresEarned}
              bonusScore={bonusScore}
              scoreBreakdown={scoreBreakdown}
            />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default AssessmentHeaderQuiz;
